import { DarkGreen } from "../shared/enums";
export default {
	overlay: DarkGreen.backgroundColor,
};
